if (!customElements.get('products-grid')) {
  customElements.define('products-grid', class extends HTMLElement {
    constructor () {
      super()

      this.gridEls = this.querySelectorAll('.grid--products')
    }

    connectedCallback () {
      this.gridEls.forEach(gridEl => {
        const packery = new Packery(gridEl, {
          itemSelector: '.grid__item',
          horizontal: true
        })
      })

      // Pause when hovering
      this.addEventListener('mouseover', () => {
        console.log('mouseover')
        this.gridEls.forEach(gridEl => {
          gridEl.style.animationPlayState = 'paused'
        })
      })
      this.addEventListener('mouseout', () => {
        console.log('mouseout')
        this.gridEls.forEach(gridEl => {
          gridEl.style.animationPlayState = 'running'
        })
      })
    }
  })
}